import { blobToDataURL, mimeTypeFromDataURL, mimeTypeFromURLOrDataURL, } from "../../utils/data_url.js";
import { drawImage, generateBlob } from "./canvas.js";
export async function resizeImageFileToFile(image, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    return new File([
        (await resizeImageBlobToBlob(image, maxWidth, maxHeight, method, adaptToDpr, canvas)),
    ], image.name, {
        type: image.type,
        lastModified: image.lastModified,
    });
}
export function resizeImage(image, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    image.src = resizeImageToDataURL(image, maxWidth, maxHeight, method, adaptToDpr, canvas);
}
export function resizeImageToDataURL(image, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    if (!canvas) {
        canvas = document.createElement("canvas");
    }
    resize(image, method, maxWidth, maxHeight, canvas, adaptToDpr);
    return canvas.toDataURL(mimeTypeFromURLOrDataURL(image.src));
}
// Resize image from Blob to Blob
export async function resizeImageBlobToBlob(blob, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    return await resizeImageSrcToBlob(await blobToDataURL(blob), maxWidth, maxHeight, method, adaptToDpr, canvas);
}
export async function resizeImageBlobToDataURL(blob, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    return await resizeImageSrcToDataURL(await blobToDataURL(blob), maxWidth, maxHeight, method, adaptToDpr, canvas);
}
async function resizeImageSrcToBlob(imgSrc, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    if (!canvas) {
        canvas = document.createElement("canvas");
    }
    resize(await createTmpImage(imgSrc), method, maxWidth, maxHeight, canvas, adaptToDpr);
    return await generateBlob(canvas, mimeTypeFromDataURL(imgSrc));
}
export async function resizeImageSrcToDataURL(imgSrc, maxWidth, maxHeight, method, adaptToDpr = true, canvas) {
    if (!canvas) {
        canvas = document.createElement("canvas");
    }
    return resizeImageToDataURL(await createTmpImage(imgSrc), maxWidth, maxHeight, method, adaptToDpr, canvas);
}
async function createTmpImage(src) {
    const tempImg = new Image();
    tempImg.crossOrigin = "";
    tempImg.src = src;
    await loadSrc(tempImg);
    return tempImg;
}
function loadSrc(image) {
    return new Promise((resolve, reject) => {
        image.onload = () => resolve();
    });
}
function fillResize(image, maxWidth, maxHeight, canvas) {
    const { dHeight, dWidth, height, width, x, y } = fillDimensions(image, maxWidth, maxHeight);
    drawImage(canvas, image, width, height, x, y, dWidth, dHeight);
}
function resize(image, method, maxWidth, maxHeight, canvas, adaptToDpr = true) {
    if (adaptToDpr) {
        maxWidth = maxWidth * window.devicePixelRatio;
        maxHeight = maxHeight * window.devicePixelRatio;
    }
    switch (method) {
        case "max":
            const { width: newWidth, height: newHeight } = maxDimensions(image, maxWidth, maxHeight);
            drawImage(canvas, image, newWidth, newHeight);
            break;
        case "fill":
            fillResize(image, maxWidth, maxHeight, canvas);
            break;
    }
}
function maxDimensions(image, width, height) {
    const imageWidth = image.width;
    const imageHeight = image.height;
    const horizScale = width / imageWidth;
    const vertScale = height / imageHeight;
    if (imageWidth <= width && imageHeight <= height) {
        return { width: imageWidth, height: imageHeight };
    }
    if (horizScale < vertScale) {
        return { width, height: imageHeight * horizScale };
    }
    return { width: imageWidth * vertScale, height };
}
function minDimensions(image, width, height) {
    const imageWidth = image.width;
    const imageHeight = image.height;
    const horizScale = width / imageWidth;
    const vertScale = height / imageHeight;
    if (imageWidth <= width || imageHeight <= height) {
        return { width: imageWidth, height: imageHeight };
    }
    if (horizScale > vertScale) {
        return { width, height: imageHeight * horizScale };
    }
    return { width: imageWidth * vertScale, height };
}
function fillDimensions(image, width, height) {
    const imageWidth = image.width;
    const imageHeight = image.height;
    const cropAspectRatio = width / height;
    // Initialise crop width and height to max
    const cropScale = Math.min(imageWidth, imageHeight * cropAspectRatio);
    const cropWidth = cropScale;
    const cropHeight = cropScale / cropAspectRatio;
    const cropX = (imageWidth - cropWidth) / 2;
    const cropY = (imageHeight - cropHeight) / 2;
    const scale = width / cropWidth;
    return {
        x: cropX,
        y: cropY,
        width: cropWidth * scale,
        height: cropHeight * scale,
        dWidth: imageWidth * scale,
        dHeight: imageHeight * scale,
    };
}
//# sourceMappingURL=image.js.map